import React from 'react'
import { formErrorMessages } from './formErrorMessages'
import { arrayFunctionHelpers } from './FunctionsHelpers/arrayHelpers'
import { currencyFunctionHelpers } from './FunctionsHelpers/currencyHelpers'
import { dateFunctionHelpers } from './FunctionsHelpers/dateHelpers'
import { numberFunctionHelpers } from './FunctionsHelpers/numberHelpers'
import { objectFunctionHelpers } from './FunctionsHelpers/objectsHelpers'
import { rutFunctionsHelpers } from './FunctionsHelpers/rutHelpers'
import { stringFunctionHelpers } from './FunctionsHelpers/stringHelpers'
import { formPatterns } from './patterns'
//import tokenHelpers from './tokenHelpers'
//import roleHelpers from './roleHelpers'
import alertHelpers from './FunctionsHelpers/alertHelpers'
import { ToastContainer } from 'react-toastify';
import { newToast, newContainer } from './tostifyConfig'
import userFunctionHelpers from './FunctionsHelpers/userHelpers'

const Helpers = {
  object: objectFunctionHelpers,
  string: stringFunctionHelpers,
  array: arrayFunctionHelpers,
  rut: rutFunctionsHelpers,
  currencys: currencyFunctionHelpers,
  number: numberFunctionHelpers,
  formPatterns: formPatterns,
  formErrorMessages: formErrorMessages,
  date: dateFunctionHelpers,
  //token: tokenHelpers,
  //userRoles: roleHelpers,
  toast: newToast,
  alert: alertHelpers,
  user: userFunctionHelpers,
  toastContainer: <ToastContainer />
}

export default Helpers
